// view-transitions.js
import { log } from './utils.js';

/** Enables one-time same-origin, non-hash navigation transitions when supported. @returns {void} */
export function enableViewTransitions() {
  if (enableViewTransitions.__wired) return;
  const prefersReducedMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;
  if (!('startViewTransition' in document)) {
    log('[vt] View Transitions API not supported');
    return;
  }
  enableViewTransitions.__wired = true;
  log('[vt] wiring view transitions');
  // Parsed once per link rather than twice: origin decides whether the link
  // is internal at all, pathname/hash decide whether it is a same-page jump.
  const classifyLink = (a) => {
    try {
      const u = new URL(a.href);
      const internal = u.origin === location.origin;
      const hashOnly = internal && u.pathname === location.pathname && !!u.hash;
      return { internal, hashOnly };
    } catch {
      return { internal: false, hashOnly: false };
    }
  };
  function enhancedNavigate(url) {
    document.startViewTransition(() => {
      location.href = url;
    });
  }
  document.addEventListener(
    'click',
    (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
        return;
      const a = e.target.closest('a');
      if (!a) return;
      if (a.target && a.target !== '_self') return;
      if (a.hasAttribute('download') || a.getAttribute('rel') === 'external') return;
      const { internal, hashOnly } = classifyLink(a);
      if (!internal || hashOnly) return;
      e.preventDefault();
      if (a.matches('[data-vt="day-title"], .day-card a')) {
        a.classList.add('vt-day-title');
        try {
          a.style.viewTransitionName = 'day-title';
        } catch {
          // viewTransitionName not supported in this browser
        }
      }
      enhancedNavigate(a.href);
    },
    { capture: true }
  );
}
